<template>
  <vs-popup id="newStockOrder" background-color-popup="#F1F1F1" fullscreen class="holamundo new-stock-order-popup"
            :title="!isNewOrder ? 'Stok Sipariş Detayı' : 'Yeni Stok Siparişi'"
            :active.sync="isActive" v-esc="escape">
    <entry-approve-logs :stockOrderEntryId="selected" @close="selected = 0;"/>
    <vs-popup class="holamundo" title="Siparişi Sil" :active.sync="deleteActive" v-esc="escapeDelete">
      <vs-row vs-type="flex" vs-w="12">
        <p><b>#{{ stockOrder.orderId }}</b> Numaralı Stok Siparişini <b>Silmek</b> İstediğinize Eminmisiniz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="escapeDelete">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
                   @click="deleteOrder">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-popup class="holamundo" title="Siparişi İptal Et" :active.sync="cancelActive" v-esc="escapeCancel">
      <vs-row vs-type="flex" vs-w="12">
        <p><b>#{{ stockOrder.id }}</b> Numaralı Stok Siparişini <b>İptal Etmek</b> İstediğinize Eminmisiniz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="escapeCancel">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-x"
                   @click="cancelOrder">
          İptal Et
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-popup class="holamundo" title="Sepeti Temizle" :active.sync="clearActive" v-esc="escapeClear">
      <vs-row vs-type="flex" vs-w="12">
        <p>Tüm Sepeti Temizlemek İstediğinize Eminmisiniz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="escapeClear">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
                   @click="clearBasket">
          Temizle
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-popup class="holamundo" title="Teslimatı Onayla" :active.sync="approveReceiveActive"
              v-esc="escapeApproveReceive">
      <vs-row vs-type="flex" vs-w="12">
        <p>Teslimatın tamamlandığını onaylıyormusunuz ? </p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="escapeApproveReceive">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-check"
                   @click="approveReceive">
          Onaylıyorum
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-row vs-type="flex" vs-w="12" v-if="stockOrder">
      <vs-col vs-type="flex" :vs-w="screenWidth < 959 ? 12 : 8" class="bg-white2 p-2"
              :class="{'pr-2' : screenWidth >= 959}">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row v-if="!isPreview" vs-type="block" vs-w="12">
            <div class="flex align-center">
              <div id="stock-order-header" class="flex-10">
                <span class="text-medium-small text-primary d-block mb-2 weight-600">
                  Hammadde Kategorileri
                </span>
                <span class="text-smaller d-block">
                  Sipariş vermek istediğiniz ürünleri aşağıdaki menü üzerinden seçerek <b>sipariş sepetine</b> ekleyebilirsiniz.
                </span>
              </div>
              <div v-if="screenWidth < 959" class="flex-2">
                <vs-button @click="toggleSideBar" class="stock-order-open-button flex" size="large"
                           color="rgba(106, 31, 19, 0.09)" icon-pack="feather" icon="icon-shopping-cart">
                </vs-button>
              </div>
            </div>
            <vs-divider></vs-divider>
            <vs-row id="stock-order-search" vs-type="flex" vs-w="12">
              <vs-col vs-type="flex" vs-w="12">
                <vs-input icon-pack="feather" icon="icon-search" v-model="stockNameFilter"
                          placeholder="Stok İsmi Ara"
                          class="bg-white text-dark weight-600 w-full text-small" size="small"/>
              </vs-col>
            </vs-row>
            <vs-row id="stock-order-list" vs-type="flex" vs-w="12" v-if="stockOrder.groupes">
              <vs-collapse class="w-full px-0">
                <vs-collapse-item v-for="group in stockOrder.groupes" :key="group.id"
                                  v-show="getGroupTotalCount(group) !== 0"
                                  class="bg-secondary2 mb-2 low-border-radius">
                  <div class="flex align-center" slot="header">
                    <vx-tooltip position="right">
                      <feather-icon v-if="group.minLimitCount > 0 || group.maxLimitCount > 0" icon='AlertTriangleIcon'
                                    svgClasses='h-5 w-5 text-warning'/>
                      <template v-slot:content>
                        <vs-row vs-type="flex" vs-w="12">
                          <vs-row v-if="group.maxLimitCount > 0" vs-type="flex" vs-w="12">
                            <feather-icon icon="PlusIcon"
                                          class="text-white circle bg-warning weight-600 p-1 h-4 w-4 mr-2"/>
                            <span>
                            <b>{{ group.maxLimitCount }}</b> adet ürün <b>stok fazlası</b>
                          </span>
                          </vs-row>
                          <vs-row v-if="group.minLimitCount > 0" vs-type="flex" vs-w="12" class="mt-1">
                            <feather-icon icon="MinusIcon"
                                          class="text-white circle bg-danger weight-600 p-1 h-4 w-4 mr-2"/>
                            <span>
                            <b>{{ group.minLimitCount }}</b> adet ürün <b>tükenmek üzere</b>
                          </span>
                          </vs-row>
                        </vs-row>
                      </template>
                    </vx-tooltip>
                    <vs-row>
                      <span class="mr-2 text-small weight-600 group-name-header" style="min-width: 16vw;">
                      {{ group.groupName }}
                    </span>
                      <span class="text-smaller">
                      <b>{{ getGroupTotalCount(group) }}</b> adet hammadde, <b>{{ getGroupSelectedCount(group) }}</b> adet seçildi.
                    </span>
                    </vs-row>
                  </div>
                  <vs-row vs-type="flex" vs-w="12" class="p-1 border-bottom border-dark">
                    <vs-col vs-type="flex" vs-w="3">
                      <vx-tooltip :title="showLeftStocks ? 'Kalan Stokları Gizle' : 'Kalan Stokları Göster'"
                                  color="primary" class="d-flex align-center"
                                  position="top">
                      <span @click="showLeftStocks = !showLeftStocks"
                            class="pointer text-smaller text-primary weight-600">
                      Stok İsmi
                    </span>
                        <feather-icon icon="MonitorIcon" class="h-4 w-4 ml-1"
                                      :class="{'text-primary' : showLeftStocks}"/>
                      </vx-tooltip>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="1" vs-justify="center">
                    <span class="text-smaller text-primary weight-600">
                      Birim Fiyat
                    </span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="4" vs-justify="center">
                    <span class="text-smaller text-primary weight-600">
                      Birim
                    </span>
                    </vs-col>
                    <vs-col v-if="showLeftStocks" vs-type="flex" vs-w="2" vs-justify="center">
                    <span class="text-smaller text-primary weight-600">
                      Sizin Stoğunuz
                    </span>
                    </vs-col>
                    <vs-col vs-type="flex" :vs-w="showLeftStocks ? 2 : 4" vs-justify="center">
                    <span class="text-smaller text-primary weight-600">
                      Sipariş Mik.
                    </span>
                    </vs-col>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12"
                          v-for="(stock,index) in group.stocks.filter(x=> stockNameFilter === '' || (stockNameFilter != '' && x.stock.rawMaterial.name.toLowerCase().includes(stockNameFilter.toLowerCase())))"
                          :key="stock.stock.id"
                          class="mt-1 p-2"
                          :class="{'bg-holoco' : stock.stock.rawMaterial.stockCode.substring(0,3) == 'HLC', 'bg-danger-low' : stock.stock.totalQuantity < stock.stock.rawMaterial.minShould && stock.stock.rawMaterial.minShould != null, 'bg-warning-low' : stock.stock.totalQuantity > stock.stock.rawMaterial.maxShould && stock.stock.rawMaterial.maxShould != null}">
                    <vs-col vs-type="flex" vs-w="3" vs-align="center">
                      <div v-if="isNewOrder" class="mr-2 d-flex align-center">
                        <feather-icon
                          v-if="stock.stock.totalQuantity < stock.stock.rawMaterial.minShould && stock.stock.rawMaterial.minShould != null"
                          icon='MinusCircleIcon'
                          svgClasses='h-5 w-5 text-white circle bg-danger'/>
                        <feather-icon
                          v-if="stock.stock.totalQuantity > stock.stock.rawMaterial.maxShould && stock.stock.rawMaterial.maxShould != null"
                          icon='PlusCircleIcon'
                          svgClasses='h-5 w-5 text-white circle bg-warning'/>
                      </div>
                      <span class="text-smaller weight-600">
                      {{ stock.stock.rawMaterial.name }}
                    </span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center">
                    <span class="text-smaller weight-600">
                      {{ $toCurrency(stock.stock.buyPrice) }}
                    </span>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="4" vs-align="center" vs-justify="center">
                    <span class="text-smaller weight-600">
                      {{ stock.unit.name }}
                    </span>
                    </vs-col>
                    <vs-col v-if="showLeftStocks" vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
                    <span class="text-smaller weight-600">
                      {{ stock.stock.totalQuantity }}
                    </span>
                    </vs-col>
                    <vs-col vs-type="flex" :vs-w="showLeftStocks ? 2 : 4" vs-align="center">
                      <vs-row v-if="stock.quantity == 0" vs-type="flex" vs-w="12">
                        <vs-row vs-type="flex" vs-w="12" vs-justify="space-between">
                          <vs-col vs-type="flex" vs-w="9" vs-sm="7">
                            <vs-input :name="(index+1)+'.Sip Miktarı'" type="number"
                                      v-validate="{required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/,minValAccept0: stock}"
                                      v-model="stock.modifiedQuantity"
                                      class="newStockOrderInput w-full text-dark weight-600"
                                      size="small"/>
                          </vs-col>
                          <vs-col vs-type="flex" vs-w="3" vs-justify="flex-end">
                            <vs-button :disabled="stock.modifiedQuantity <= 0 || errors.has(index+1 +'.Sip Miktarı')"
                                       class="low-border-radius p-4"
                                       size="small" color="success" icon-pack="feather" icon="icon-plus"
                                       @click="addToBasket(stock)"/>
                          </vs-col>
                        </vs-row>
                        <vs-row vs-type="flex" vs-w="12">
                        <span class="text-danger text-sm" v-show="errors.has(index+1 +'.Sip Miktarı')">{{
                            errors.first(index + 1 + '.Sip Miktarı')
                          }}</span>
                        </vs-row>
                      </vs-row>
                      <div v-else class="d-flex w-full justify-center">
                        <span class="text-success weight-600 text-smaller">
                          Sepette
                        </span>
                      </div>
                    </vs-col>
                  </vs-row>
                </vs-collapse-item>
              </vs-collapse>
            </vs-row>
          </vs-row>
          <vs-row v-else vs-type="block" vs-w="12" class="p-2">
            <vs-row id="stock-order-header" vs-type="block" vs-w="12">
              <vs-col vs-type="block" vs-w="10">
                <span class="text-medium-small text-primary d-block mb-2 weight-600">
                {{ isNewOrder ? "Sipariş Önizleme" : "Sipariş Detayı" }}
                </span>
                <span v-if="isNewOrder" class="text-smaller d-block">
                  Aşağıda bulunan stokları belirtilen miktarda, belirtilen birimlerde sipariş vermek üzeresin. <b>Son kontrollerin yapıldığından</b> emin olun.
                </span>
                <span v-else-if="!$isCenterBranch() && !$isRegionalCenterBranch()" class="text-smaller d-block weight-500">
                  Vermiş olduğunuz sipariş doğrultusunda <b>merkezden</b> talep edilen <b>stoklar</b> aşağıda listelenmektedir.
                </span>
                <span v-else class="text-smaller d-block weight-500">
                  Şube tarafından sipariş doğrultusunda talep edilen stoklar aşağıda listelenmektedir.
                </span>
              </vs-col>
              <vs-col vs-type="flex" vs-w="2" vs-justify="flex-end">
                <vx-tooltip text="Excel Export" position="top"
                            v-if="stockOrder.id && stockOrder.id > 0 && stockOrder.status != -1">
                  <vs-button @click="getExcel" class="mr-1"
                             color="primary" icon-pack="feather" icon="icon-download">
                  </vs-button>
                </vx-tooltip>
                <vs-button v-if="screenWidth < 959" @click="toggleSideBar" class="ml-1 p-5"
                           color="rgba(106, 31, 19, 0.09)" icon-pack="feather" icon="icon-shopping-cart">
                </vs-button>
              </vs-col>
            </vs-row>
            <vs-divider></vs-divider>
            <vs-row id="stock-order-search" vs-type="flex" vs-w="12">
              <vs-input icon-pack="feather" icon="icon-search" v-model="stockNameFilter"
                        placeholder="Stok İsmi Ara"
                        class="bg-white text-dark weight-600 w-full text-small" size="small"/>
            </vs-row>
            <vs-row id="stock-order-list" vs-type="flex" vs-w="12" v-if="stockOrder.groupes">
              <vs-row vs-type="flex" vs-w="12" class="border-bottom py-2">
                <vs-col vs-type="flex"
                        :vs-w="(stockOrder.status == 0 || stockOrder.status == 3 || stockOrder.status == 5) ? 2.5 : 3">
                <span class="text-primary weight-600 text-smaller">
                  Ürün Adı
                </span>
                </vs-col>
                <vs-col vs-type="flex" vs-w="3" vs-justify="center">
                <span class="text-primary weight-600 text-smaller">
                  Birim
                </span>
                </vs-col>
                <vs-col vs-type="flex"
                        v-if="(stockOrder.status == 0 || stockOrder.status == 3 || stockOrder.status == 5)" vs-w="2"
                        vs-justify="center">
                <span class="text-primary weight-600 text-smaller">
                  Kalan Gönderim
                </span>
                </vs-col>
                <vs-col vs-type="flex"
                        :vs-w="(stockOrder.status == 0 || stockOrder.status == 3 || stockOrder.status == 5) ? 2 : 3"
                        vs-justify="center">
                <span v-if="stockOrder.status == 4 || stockOrder.status == 5"
                      class="text-primary weight-600 text-smaller">
                  {{ ($isCenterBranch()||$isRegionalCenterBranch()) ? 'Gönd. Miktar' : 'Gelen Miktar' }}
                </span>
                  <span v-else-if="stockOrder.status == 3" class="text-primary weight-600 text-smaller">
                  {{ ($isCenterBranch()||$isRegionalCenterBranch()) ? 'Gönd. Miktar' : 'Son Gönderilen' }}
                </span>
                  <span v-else class="text-primary weight-600 text-smaller">
                  Miktar
                </span>
                </vs-col>
                <vs-col v-if="stockOrder.totalPrice" vs-type="flex" vs-justify="center" vs-w="2">
                  <span class="text-primary weight-600 text-smaller">
                    Tutar
                  </span>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <vs-row v-for="(item,index) in previewOrderList" :key="index" vs-type="flex" class="border-bottom"
                        vs-w="12" vs-align="center">
                  <vs-col vs-type="block"
                          :vs-w="(stockOrder.status == 0 || stockOrder.status == 3 || stockOrder.status == 5) ? 2.5 : 3"
                          class="py-4 px-2">
                <span class="text-secondary text-smaller weight-600 d-block opacity-50">
                  <b class="text-primary">{{ item.stock.rawMaterial.rawMaterialCategoryName }}</b> - Ürün {{
                    index + 1
                  }}
                </span>
                    <span class="d-block text-dark text-sm weight-600 mt-3">
                  {{ item.stock.rawMaterial.name }}
                </span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="3" vs-justify="center">
                  <span class="d-block text-xs text-center weight-500">
                    {{ item.unit.name }}
                  </span>
                  </vs-col>
                  <vs-col v-if="(stockOrder.status == 0 || stockOrder.status == 3 || stockOrder.status == 5)" vs-w="2"
                          vs-type="flex"
                          vs-justify="center">
                  <span v-if="item.leftQuantity > 0" class="text-sm border-bottom border-dark px-2 weight-600">
                   {{ item.leftQuantity }}
                  </span>
                    <span v-else>
                    <feather-icon icon="CheckIcon" svgClasses="h-4 w-4 text-success"/>
                  </span>
                  </vs-col>
                  <vs-col vs-type="flex"
                          :vs-w="(stockOrder.status == 0 || stockOrder.status == 3 || stockOrder.status == 5) ? 2 : 3"
                          vs-justify="center" class="px-1">
                  <span
                    v-if="stockOrder.status != 1 && stockOrder.status != -1 && stockOrder.status != 0 && stockOrder.status != 6"
                    class="mr-auto"></span>
                    <div v-if="(stockOrder.status == 0 || stockOrder.status == 3) && ($isCenterBranch()||$isRegionalCenterBranch())"
                         class="d-block w-full text-center">
                      <vs-input :name="(index+1)+'.Gönd Miktar'" v-if="!item.isComplete"
                                v-validate="{max_value: item.leftQuantity,required:true,regex: /^\d{0,10}(\.\d{0,10}){0,1}$/}"
                                v-model="item.modifiedQuantity"
                                class="d-block px-2 input-center w-full text-dark weight-600"
                                size="small"/>
                      <span v-else class="text-smaller text-success text-center weight-600">
                      Tamamlandı !
                    </span>
                      <span class="text-danger text-xs d-block w-full px-2"
                            v-show="errors.has((index+1)+'.Gönd Miktar')">{{
                          errors.first((index + 1) + '.Gönd Miktar')
                        }}</span>
                    </div>
                    <span v-else-if="(stockOrder.status == 0 || stockOrder.status == 3) && (!$isCenterBranch() && !$isRegionalCenterBranch())"
                          class="text-sm border-bottom border-dark px-2 weight-600">
                   {{ item.lastSendQuantity }}
                  </span>
                    <span v-else-if="stockOrder.status == 4 || stockOrder.status == 5"
                          class="text-sm border-bottom border-dark px-2 weight-600">
                   {{ item.modifiedQuantity }}
                  </span>
                    <span v-else class="text-sm border-bottom border-dark px-2 weight-600">
                   {{ item.quantity }}
                  </span>
                    <vs-button class="ml-auto p-3"
                               v-if="stockOrder.status != 1 && stockOrder.status != -1 && stockOrder.status != 0 && stockOrder.status != 6"
                               color="primary" icon-pack="feather" icon="icon-search" radius size="small"
                               @click="selected = item.id"/>
                  </vs-col>
                  <vs-col v-if="item.price" vs-w="2" vs-type="flex">
                    {{ $toCurrency(item.price) }}
                  </vs-col>
                </vs-row>
              </vs-row>
            </vs-row>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-4 pl-2">
            <vs-textarea :readonly="stockOrder.status != 1 && stockOrder.status != -1" class="half-friendly-border"
                         v-model="stockOrder.description" label="Sipariş Açıklaması"/>
          </vs-row>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" v-if="screenWidth > 959" vs-w="4" class="stock-order-basket-header pt-0 pl-2">
        <vs-col vs-type="flex" vs-w="12">
          <stock-order-basket id="newStockOrderBasket" ref="stockOrderBasket" :is-preview="isPreview" :checker="errors.items.length === 0"
                              :stockOrder="stockOrder"
                              @onClearBasket="onClearBasket" @onEdit="onEdit" @onRemoveFromBasket="removeFromBasket"
                              @reload="onReload" @onApproveReceive="onApproveReceive" @onPreviewOrder="onPreviewOrder"
                              @onDeleteOrder="onDeleteOrder"
                              @onCancelOrder="onCancelOrder"/>
        </vs-col>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12">
      <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
                  class="stock-order-open-sidebar items-no-padding" spacer v-model="isSideBarActive"
                  v-esc="escapeSideBar">
        <stock-order-basket ref="stockOrderBasket" :is-preview="isPreview" :checker="errors.items.length === 0"
                            :stockOrder="stockOrder"
                            @onClearBasket="onClearBasket" @onEdit="onEdit" @onRemoveFromBasket="removeFromBasket"
                            @reload="onReload" @onApproveReceive="onApproveReceive" @onPreviewOrder="onPreviewOrder"
                            @onDeleteOrder="onDeleteOrder"
                            @onCancelOrder="onCancelOrder"
                            @onCloseSideBar="toggleSideBar"/>
      </vs-sidebar>
    </vs-row>
  </vs-popup>
</template>

<script>
import EntryApproveLogs from "./StockOrderEntryApproveLog.vue";
import StockOrderBasket from "@/views/pages/StockOrder/StockOrderBasket";
import {
  canceledStockOrder,
  approveReceive,
  changeState,
  getExcel,
  deleteStockOrder,
  deleteStockOrderForDealer,
  getEmptyStockOrder
} from "@/api/StockOrder.js";
/* eslint-disable */
export default {
  name: "NewStockOrder",
  components: {StockOrderBasket, EntryApproveLogs},
  data() {
    return {
      selected: 0,
      stockNameFilter: '',
      stockOrder: {},
      isActive: false,
      selectedStockOrder: {},
      deletedId: null,
      isPreview: false,
      showLeftStocks: false,
      deleteActive: false,
      cancelActive: false,
      clearActive: false,
      approveReceiveActive: false,
      checker: true,
      isSideBarActive: false,
      screenWidth: window.innerWidth,
    }
  },
  computed: {
    previewOrderList() {
      if (this.stockNameFilter != '' && this.stockNameFilter != null) {
        if (this.stockOrder.status == 5 || this.stockOrder.status == 4) {
          return this.stockOrder.groupes.flatMap(group => group.stocks).filter(x => (x.modifiedQuantity > 0 || x.leftQuantity > 0) && x.quantity > 0 && x.stock.rawMaterial.name.toLowerCase().includes(this.stockNameFilter.toLowerCase()));
        } else {
          return this.stockOrder.groupes.flatMap(group => group.stocks).filter(x => x.quantity > 0 && x.stock.rawMaterial.name.toLowerCase().includes(this.stockNameFilter.toLowerCase()));
        }
      } else {
        if (this.stockOrder.status == 5 || this.stockOrder.status == 4) {
          return this.stockOrder.groupes.flatMap(group => group.stocks).filter(x => (x.modifiedQuantity > 0 || x.leftQuantity > 0) && x.quantity > 0);
        } else {
          return this.stockOrder.groupes.flatMap(group => group.stocks).filter(x => x.quantity > 0);
        }

      }

    },
    isNewOrder() {
      return this.stockOrder && this.stockOrder.id ? false : true;
    },
    hasAcceptableOrder() {
      if (!this.stockOrder) return false;
      if (!this.stockOrder.groupes) return false;
      if (!this.stockOrder.groupes.some(x => x.stocks.some(y => y.quantity > 0))) return false;
      return this.stockOrder.groupes.every(x => x.stocks.every(y => parseFloat(y.quantity) >= 0));
    },
  },
  methods: {
    onApproveReceive() {
      this.approveReceiveActive = true;
    },

    onResize() {
      this.screenWidth = window.innerWidth
    },
    approveReceive() {
      approveReceive(this.stockOrder.id).then(res => {
        if (res && res.status == 200) {
          this.$vs.notify({
            color: "success",
            title: "Teslimat Onaylandı",
            text: "Sipariş Stoklara İşlendi !"
          });
          this.escapeApproveReceive();
          this.onReload();
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Stoklar Onaylama Hata : " + res.status,
            text: "Sipariş Envantere İşlenemedi !"
          });
        }
      }).catch(error => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sipariş Onaylanamadı !"
        });
      });
    },
    escapeApproveReceive() {
      if (this.approveReceiveActive) this.approveReceiveActive = false;
    },
    escapeDelete() {
      if (this.deleteActive) this.deleteActive = false;
    },
    escapeClear() {
      if (this.clearActive) this.clearActive = false;
    },
    escapeCancel() {
      if (this.cancelActive) this.cancelActive = false;
    },
    deleteOrder() {
      if (this.$isRegionalCenterBranch()) {
        deleteStockOrderForDealer(this.stockOrder.id).then(res => {
        if (res && res.status == 200) {
          this.$vs.notify({
            color: "success",
            title: "Silme İşlemi",
            text: "Sipariş Başarıyla Silindi"
          });
          this.escapeDelete();
          this.escape();
          this.$emit("reload");
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      });
      } else {
        deleteStockOrder(this.stockOrder.id).then(res => {
        if (res && res.status == 200) {
          this.$vs.notify({
            color: "success",
            title: "Silme İşlemi",
            text: "Sipariş Başarıyla Silindi"
          });
          this.escapeDelete();
          this.escape();
          this.$emit("reload");
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      });
      }
      
    },
    cancelOrder() {
      canceledStockOrder(this.stockOrder.id).then(res => {
        if (res && res.status == 200) {
          this.$vs.notify({
            color: "success",
            title: "İptal İşlemi",
            text: "Sipariş Başarıyla İptal Edildi"
          });
          this.escapeCancel();
          this.escape();
          this.$emit("reload");
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "İptal İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      });
    },
    onDeleteOrder() {
      this.deleteActive = true;
    },
    onCancelOrder() {
      this.cancelActive = true;
    },
    onPreviewOrder() {
      this.isPreview = true;
    },
    onClearBasket() {
      this.clearActive = true;
    },
    clearBasket() {
      this.stockOrder.groupes.flatMap(group => group.stocks).forEach(item => item.quantity = 0);
      this.escapeClear();
    },
    removeFromBasket(item) {
      item.quantity = 0;
    },
    getGroupSelectedCount(group) {
      if (this.stockNameFilter != '') {
        return group.stocks.filter(x => x.quantity > 0 && x.stock.rawMaterial.name.toLowerCase().includes(this.stockNameFilter.toLowerCase())).length;
      } else return group.stocks.filter(x => x.quantity > 0).length;
    },
    getGroupTotalCount(group) {
      if (this.stockNameFilter != '') {
        return group.stocks.filter(x => x.stock.rawMaterial.name.toLowerCase().includes(this.stockNameFilter.toLowerCase())).length;
      } else return group.stocks.length;
    },
    getEmptyStockOrder: async function () {
      var emptyStockOrder = await getEmptyStockOrder();
    },
    onReload() {
      this.isActive = false;
      this.$emit("reload");
    },
    onEdit() {
      this.isPreview = false;
    },
    addToBasket(stock) {
      stock.quantity = stock.modifiedQuantity;
    },
    getExcel() {
      getExcel(this.stockOrder.id).then(res => {
        if (res && res.status == 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Sipariş Detay-' + this.stockOrder.orderId + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Excel Export İşlemi Başarısız !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    checkOrder: async function () {
      let checker = await this.$validator.validateAll();
      if (!checker) return;
      this.stockOrder = _.cloneDeep(this.stockOrder.groupes.filter(x => x.stocks.filter(y => y.quantity > 0)));
    },
    changeOrderState: async function () {
      await changeState(this.stockOrder).then(res => {
        this.stockOrder = res.data;
        this.$store.dispatch("stockOrder/changeStateStockOrder", res.data);
      });
    },
    saveCenterBranchOrders: async function () {
      let checker = await this.$validator.validateAll();
      if (checker) {

      }
    },
    escape() {
      if (this.isActive == true && this.selected == 0) {
        this.isActive = false;
      }
    },
    initValues() {
      this.stockOrder = {}
    },
    toggleSideBar() {
      this.isSideBarActive = !this.isSideBarActive
    },
    escapeSideBar() {
      this.isSideBarActive = false
    }
  },
  watch: {
    isActive(val) {
      if (!val) this.initValues();
    },
    windowWidth(newWidth) {
      this.screenWidth = newWidth;
    }
  },
  created() {
    this.$validator.extend('minValAccept0', {
      getMessage(field, params, data) {
        return (data && data.message) || 'Min Sipariş Tutarı : ' + parseFloat(params.stock.rawMaterial
          .minimumOrder)
      },
      validate: async function (value, field) {
        let parsedValue = parseFloat(value);
        let parsedField = parseFloat(field.stock.rawMaterial.minimumOrder)
        if (parsedValue == 0 || parsedValue >= parsedField)
          return true;
        else return false;
      }
    });
  },
  changeOrderState: async function () {
    await changeState(this.stockOrder).then(res => {
      this.stockOrder = res.data;
      this.$store.dispatch("stockOrder/changeStateStockOrder", res.data)
    });
  },
  beforeUpdate() {
    //Burada ViewState kontrol edilecek.
    if (this.stockOrder && this.stockOrder.viewState) {
      if (this.$isCenterBranch() && this.$isRegionalCenterBranch()) {
        if (this.stockOrder.status === 1 || this.stockOrder.status == 2) {
          this.changeOrderState();
        }
      } else {
        if (this.stockOrder.status !== 1 && this.stockOrder.status != 2) {
          this.changeOrderState();
        }
      }
    }
  }
}
</script>

<style>
  .bg-holoco {
    background-color: rgba(255, 190, 15, 0.2);
  }
</style>

<style>
#stock-order-search input {
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-radius: 0 !important;
}

#stock-order-search .vs-con-input span {
  padding-top: 0.5rem !important;
}

#stock-order-list .icon-scale.material-icons {
  font-size: 2rem !important;
}

#stock-order-list .vs-collapse-item--content {
  background-color: white;
}

#stock-order-list .con-content--item {
  padding-left: 0;
  padding-right: 0;
}

@media screen and (min-width: 959px) {
  #stock-order-list {
    max-height: 48vh;
    overflow-x: auto;
  }
}
#newStockOrder ::-webkit-scrollbar {
  width: 1.4rem;
  border-radius: 3px;
  background-color: lightgrey;
  display: block !important;
}

#newStockOrder ::-webkit-scrollbar-thumb {
  background-color: #8f3f33;
  border-radius: 3px;
  width: 1.5rem !important;
}
</style>
